import moment from 'moment';
import React, { Component, Fragment, useEffect, useRef, useState } from 'react'
import _ from "lodash";
import Select from "react-select";
import { browserHistory } from 'react-router';
import { deleteNewDriverPay, fetchUsers, getAllNewSettlements, getDriverForDeduction, getTerminal, manualDriverPay } from '../../../pages/tms/services';
import { approveNewDeduction, displayName, getCarrierByUserId, getDriverOrderLocation, getNewTranscation, getPlace, getPricingSettingsOptions, getStorage, isMilitaryTime, makeOptionsForSelect, showForCompany, showForTerminal, toastr, updateNewTranscation } from '../../../services'
import { IconAngleArrowDown, IconCalendar, IconDelete, IconPlus, IconSaveAsDefault, IconTrash } from '../../Common/Icons';
import configuration from '../../../config'
import confirm from '../../Common/ConfirmAert';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import { newSmallSelectStyle } from "../../../assets/js/select-style";

import DateTimePicker from '../../../pages/tms/NewDispatcher/DispatcherTable/Components/CustomDatePicker/DateTimePicker';
import { getAllLoadsStatus } from '../../../pages/tms/carrier/Transcation/actionCreator';
import { LoaderBar } from '../../Common/LoaderBar';
import { changeWeek } from '../../../services';
import { CustomIconAddUser } from '../../Common/CustomIcons/Index';
import NumberFormater from './Components/NumberFormater';
import { createDriverPayStatus, deleteDriverPayStatus } from '../actions';

import { getUserById } from '../../FetchData/actionCreators';
import Avatar from '../../Common/Avatar';
import SelectCustomComponent from '../../../pages/tms/SelectComponent';
import DeleteCell from './Components/DeleteCell';
import { getDrivers } from '../../Common/FloatingChat/actionCreators';
import RedirectToRates from './Components/RedirectToRates';
import DateWrapper from '../../../pages/tms/NewDispatcher/DispatcherTable/Components/CustomDatePicker/DateWrapper';

const firebase = configuration.firebase;

const pricingSettingsOptions = getPricingSettingsOptions();
const newDriverPay = {
    driver: null,
    from: null,
    to: null,
    amount: null,
    status: null,
    date: null
}
const sortingOptions = {
    Terminal: "terminal.name",
    Load: "reference_number",
    Time: "time",
    Owner: "fleetTruckOwner.company_name",
    Truck: "truck.equipmentID",
    Driver: "createdBy.name",
    Amount: "calculateAmount",
    "Load Status": "renderStatus",
    From: "from",
    To: "to",
};

class DriverPay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transcations: [],
            allDrivers: [],
            startDate: null,
            endDate: null,
            from: null,
            to: null,
            showSearch: true,
            order: -1,
            searchTerm: "",
            terminal: '',
            terminals: [],
            allLoadStatus: [],
            terminal: null,
            driverPayTerminal: null,
            filterStatus: [],
            selectedLoad: undefined,
            sort: undefined,
            asce: true,
            isLoadingBarShow: false,
            choosenTerminals: [],
            settlementData: [],
            fromDate: moment(),
            toDate: moment(),
            isSaving: false,
            isStatusHovered: null,
            selectedDate: moment(),
            isTerminal: false,
            missingDocType: [],
            isRequied: "transition-white-field",
            isFailed: "transition-white-field",
            isApiCall: false,
            newDriverPay: newDriverPay,
            address: [],
            filterFrom: false,
            filterTo: false,
            rowIndex: null,
            DateAndTime: "",
            selectedCell:null,
            driverQuery: null,
        };
        this.userTimeZone = getStorage("timeZone") || moment.tz.guess()
        this.handleOnChange = this.handleOnChange.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.unselectCell = this.unselectCell.bind(this);
        this.removeStatus = this.removeStatus.bind(this);
        this.userTimeFormat = isMilitaryTime();
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target) &&
            (document.querySelector(".tab-loads").contains(event.target) ||  document.querySelector(".fcpopup__left").contains(event.target))
        ) {
            if (this.state.addDriverPay) {
                if (this.state.isDateSelect || this.state.ShowDriverList) {
                    this.setState({ isDateSelect: false, ShowDriverList: false },()=>{
                        this.addManual()
                    })
                } else {
                    this.addManual()
                }
            }
        }
    }

    redirectToRates = (payItem) => {
        if (payItem.driverPayRateId) {
            browserHistory.push('/tms/driver-pay-rates?rateId=' + payItem.driverPayRateId);
        } else if (payItem.dynamicDriverPayId) {
            browserHistory.push('/dynamic-driverPay?rateId=' + payItem.dynamicDriverPayId);
        }
    }


    getFromTo(val){
        return new Promise( (resolve,reject)=>{
            fetchUsers("carrier/getTMSCustomers", { searchTerm: val, limit: 10, }).then((res)=>{
                return resolve(res.data.data)
            })
        })
        
    }
    getDriverList(val){
        return new Promise( (resolve,reject)=>{
            getDrivers(val).then((res)=>{
                return resolve(res)
            })
        })
        
    }
    componentDidMount() {
        const currentUser = JSON.parse(getStorage("loggedInUser"));
        let carrierId = currentUser._id;
        if (currentUser.role === "driver") {
            carrierId = currentUser.driver.carrier;
        }
        if (currentUser.role === "fleetmanager") {
            carrierId = currentUser.fleetManager.carrier;
        }
        let isTerminal = showForTerminal();
        this.setState({ isTerminal: isTerminal });
        if (_.get(this.props, "location.pathname") !== "/tms/billing/driver-pay") {
            if (isTerminal) {
                getTerminal().then((response) =>
                    this.setState({
                        terminals: response.data.data ? response.data.data : [],
                    })
                );
            }
        }
        this.getDriverList("a").then(res=>{
            this.setState({allDrivers:res})
        })
        if (
            this.props.location.query.reference_number ||
            this.props.reference_number
        ) {
            this.setState({ showSearch: false }, () => {
                let reference_number = encodeURIComponent(
                    this.props.location.query.reference_number
                );
                if (this.props.reference_number) {
                    reference_number = encodeURIComponent(this.props.reference_number);
                }
                const query = Object.assign({}, this.state.query, { reference_number });
                this.getTranscation(query);
            });
        }

        if (
            (getStorage("currentUserRole") == "fleetmanager" &&
                configuration

                    .idForTerminal.indexOf(
                        JSON.parse(getStorage("loggedInUser")).fleetManager.carrier
                    ) != -1) ||
            (getStorage("currentUserRole") == "carrier" &&
                configuration.idForTerminal.indexOf(getStorage("currentUserID")) != -1)
        ) {
            getTerminal().then((response) => {
                let terminals = response.data.data;
                if (
                    getStorage("currentUserRole") == "fleetmanager" &&
                    configuration.idForTerminal.indexOf(
                        JSON.parse(getStorage("loggedInUser")).fleetManager.carrier
                    ) != -1
                ) {
                    let fleetTerminal = JSON.parse(getStorage("loggedInUser"))
                        .fleetManager.terminals;
                    terminals = terminals.filter(
                        (D) => fleetTerminal.indexOf(D._id) > -1
                    );
                }
                this.setState({ terminals });
            });
        }
        getCarrierByUserId(carrierId).then((mainAccount) => {
            let { settlementSettings } = mainAccount.data.data;
            this.setState(
                {
                    settlementSettings: settlementSettings ? settlementSettings : {},
                },
                () => {
                    if (
                        settlementSettings &&
                        settlementSettings.day &&
                        settlementSettings.duration
                    ) {
                        let query = {
                            homeTerminalTimezone: this.userTimeZone,
                            limit: 1,
                        };
                        getAllNewSettlements(query).then((data) => {
                            this.setState({ settlementData: data.data.data });
                        });
                    }
                }
            );
        });
      
        if (getStorage("loggedInUser") != null) {
            let reference_number;
            if (this.props.selectedLoads) {
                reference_number = this.props.selectedLoads.reference_number;
            } else {
                if (this.props.loads && this.props.loads.reference_number) {
                    reference_number = this.props.loads.reference_number;
                } else if (this.props.id) {
                    reference_number = this.props.id;
                } else if (
                    this.props.location &&
                    this.props.location.query &&
                    this.props.location.query.reference_number
                ) {
                    reference_number = this.props.location.query.reference_number;
                }
            }
            this.userPresense = firebase
                .database()
                .ref(
                    `${carrierId}/presense/${reference_number}/driverpay/${currentUser._id}`
                );


            if (this.userPresense) {
                this.userPresense.set(true);
            }
        }
        document.addEventListener("mousedown", this.handleClickOutside);
        getAllLoadsStatus().then(data => {
            this.setState({ allLoadStatus: data.driverPayStatus || [] })
        })
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    createStatus = (status) => {
        let data = new FormData()
        data.append("status", status)
        createDriverPayStatus(data).then(data => {
            this.setState({ allLoadStatus: data.driverPayStatus || [] })
        })
    }
    deleteStatus = (status) => {
        let data = new FormData()
        data.append("status", status)
        deleteDriverPayStatus(data).then(data => {
            this.setState({ allLoadStatus: data.driverPayStatus || [] })
        })
    }


    removeStatus(status){
        return new Promise((resolve,reject)=>{
            let data = new FormData()
            data.append("status", status)
            deleteDriverPayStatus(data).then(data => {
                this.setState({ allLoadStatus: data.driverPayStatus || [] })
                resolve(data.driverPayStatus)
            }).catch(err => console.log(err))
        })
       
    }

    selectCell=(name)=>{
        this.setState({
            selectedCell:name
        });
    }
    unselectCell=()=>{
        this.setState({
            selectedCell:null
        });
    }
    deleteNewDriverPay = (params) => {
        confirm("Delete Driver Pay Rate?", "Are you sure to delete Driver Pay Rate?", (confirm) => {
            if (confirm) {
                params.from = "transcation";
                deleteNewDriverPay(params).then((result) => {
                    let transcations = JSON.parse(JSON.stringify(this.state.transcations));
                    transcations = transcations.filter((data) => data._id != params._id);
                    this.setState({ transcations });
                    toastr.show("Deleted!", "success");
                });
            }
        });
    };

    transitionEffect = (field, color) => {
        const element = document.querySelector(`.${field}`);
        if(color){
            element?.classList.remove("background-failure");
            element?.classList.add("background-success");
          setTimeout(()=>{
            element?.classList.remove("background-success","text-danger");
          },400)
        }else {
            element?.classList.add("background-error","text-danger");
            setTimeout(()=>{
                element?.classList.add("background-failure","text-danger");
                element?.classList.remove("background-error","text-danger");
            },400)
        }
      }

    getTranscation = (query = {}) => {
        this.setState({ isLoadingBarShow: true })
        if (this.state.missingDocType.length > 0) {
            query.missingDocType = JSON.stringify(this.state.missingDocType.map((d) => d.value))
        }

        getNewTranscation({
            ...query,
            from: this.state.startDate,
            to: this.state.endDate,
            order: 1
        })
            .then(async (response) => {
                let transcations =
                    !response.data.data || response.data.data.result == null
                        ? []
                        : response.data.data.result;
                transcations = transcations.filter((trans) => trans._id);
                let updatedTransaction = [];
                try {
                    updatedTransaction = await Promise.all(transcations.map(async (d) => {
                        let res = await this.getUserProfileUrl(d.createdBy._id);
                        return { ...d, profilePicture: res };
                    }))
                } catch (error) {
                    console.warn(error.message)
                }
                this.setState({
                    transcations: updatedTransaction,
                    isLoadingBarShow: false
                });
            }).catch(err => {
                this.setState({ isLoadingBarShow: false })
            })
            .finally((err) => {
                this.setState({ isLoadingBarShow: false });
            });
    };

    getUserProfileUrl = async (val) => {
        let res = await getUserById(val);
        return res?.profilePicture;
    }


    addManual = () => {
        const { driver, from, to, amount, status, date, startDate, endDate, time, terminal } = this.state.newDriverPay
        this.unselectCell()
        if (!driver || !from || !to || !amount || !status || !date || !time) {
            this.setState({ isRequied: "background-error" }, () => {
                setTimeout(() => {
                    this.setState({ isRequied: "background-failure" })
                }, 400);
            })

            return;
        }
        if (this.state.isApiCall) return
        const newFormData = new FormData();

        newFormData.append("startDate", startDate);
        newFormData.append("endDate", endDate);
        newFormData.append("time", time);
        newFormData.append("description", status);
        newFormData.append("amount", parseFloat(amount));
        newFormData.append("driverId", driver.value);
        if (
            this.props.location &&
            this.props.location.query &&
            this.props.location.query.reference_number
        ) {
            newFormData.append(
                "reference_number",
                this.props.location.query.reference_number
            );
        } else {
            newFormData.append(
                "reference_number",
                this.props.selectedLoads.reference_number
            );
        }
        newFormData.append("from", from);
        newFormData.append("to", to);
        if (terminal) {
            newFormData.append("terminal", terminal.value);
        }
        newFormData.append("loadId", this.props.selectedLoads?._id)

        this.setState({ isApiCall: true })
        manualDriverPay(newFormData)
            .then(async(response) => {
                let data = response.data.data
                this.props.blockTabChange(false);
                let transcations = this.state.transcations.slice();
                let res = await this.getUserProfileUrl(data.createdBy._id);
                data.profilePicture = res
                transcations.push(data);
                this.setState({ isSaving: false, showManual: false, transcations, newDriverPay: newDriverPay, addDriverPay: false, isApiCall: false },()=>{
                    const rowId = transcations.length
                    this.transitionEffect(`row-${rowId-1}`,true)
                });
            })
            .catch((error) => {
                this.props.blockTabChange(false);
                this.setState({ isSaving: false, isApiCall: false });
            });
    };

    getLocation = (statusOrder, createdBy, status) => {
        let location = {
            from: [],
            to: [],
        };

        if (status == "DELIVERED") {
            var findIndex = JSON.parse(JSON.stringify(statusOrder)).findIndex(
                (status) => {
                    return status.status == "ARRIVED_PICKUP";
                }
            );
            var D = statusOrder[findIndex + 2];
            if (D && D.status == "DROPPED" && D.isCompleted && D.address) {
                let formattedData = D.address.address.split(",");
                location.from = [
                    {
                        company: D.company,
                        street: formattedData[0],
                        city: D.city ? D.city : formattedData[1],
                        state: D.state ? D.state : formattedData[2],
                    },
                ];
            } else {
                var D = statusOrder[findIndex];
                if (D && D.address && D.address.address) {
                    let formattedData = D.address.address.split(",");
                    location.from = [
                        {
                            company: D.company,
                            street: formattedData[0],
                            city: D.city ? D.city : formattedData[1],
                            state: D.state ? D.state : formattedData[2],
                        },
                    ];
                }
            }
            var findIndex = JSON.parse(JSON.stringify(statusOrder)).findIndex(
                (status) => {
                    return status.status == "DELIVERED";
                }
            );
            var D = statusOrder[findIndex];
            if (D && D.address && D.address.address) {
                let formattedData = D.address.address.split(",");
                location.to = [
                    {
                        company: D.company,
                        street: formattedData[0],
                        city: D.city ? D.city : formattedData[1],
                        state: D.state ? D.state : formattedData[2],
                    },
                ];
            }
        }
        if (status == "ARRIVED_PICKUP") {
            var driverId;
            var hasChanged = false;

            var findIndex = JSON.parse(JSON.stringify(statusOrder)).findIndex(
                (status) => {
                    return status.address;
                }
            );
            var D = statusOrder[findIndex];
            if (D && D.address && D.address.address) {
                let formattedData = D.address.address.split(",");
                location.from = [
                    {
                        company: D.company,
                        street: formattedData[0],
                        city: D.city ? D.city : formattedData[1],
                        state: D.state ? D.state : formattedData[2],
                    },
                ];
            }
            var findIndex = statusOrder.findIndex((status) => {
                return status.status == "DROPPED" && status.isCompleted;
            });
            if (findIndex != -1 && statusOrder[findIndex]) {
                var D = statusOrder[findIndex];
                if (D && D.address && D.address.address) {
                    let formattedData = D.address.address.split(",");
                    location.to = [
                        {
                            company: D.company,
                            street: formattedData[0],
                            city: D.city ? D.city : formattedData[1],
                            state: D.state ? D.state : formattedData[2],
                        },
                    ];
                } else {
                    var findIndex = JSON.parse(JSON.stringify(statusOrder))
                        .slice()
                        .reverse()
                        .findIndex((status) => {
                            return status.isCompleted == true;
                        });
                    var D = statusOrder[findIndex];
                    if (D && D.address && D.address.address) {
                        let formattedData = D.address.address.split(",");
                        location.to = [
                            {
                                company: D.company,
                                street: formattedData[0],
                                city: D.city ? D.city : formattedData[1],
                                state: D.state ? D.state : formattedData[2],
                            },
                        ];
                    }
                }
            } else {
                var findIndex = JSON.parse(JSON.stringify(statusOrder))
                    .slice()
                    .reverse()
                    .findIndex((status) => {
                        return status.status == "DELIVERED";
                    });
                var D = statusOrder[findIndex];
                if (D && D.address && D.address.address) {
                    let formattedData = D.address.address.split(",");
                    location.to = [
                        {
                            company: D.company,
                            street: formattedData[0],
                            city: D.city ? D.city : formattedData[1],
                            state: D.state ? D.state : formattedData[2],
                        },
                    ];
                }
            }
        }
        if (status == "COMPLETED") {
            var findIndexForDelivery = JSON.parse(
                JSON.stringify(statusOrder)
            ).findIndex((status) => {
                return status.status == "DELIVERED";
            });
            var D = statusOrder[findIndexForDelivery];
            if (D && D.address && D.address.address) {
                var formattedData = D.address.address.split(",");
                location.from = [
                    {
                        company: D.company,
                        street: formattedData[0],
                        city: D.city ? D.city : formattedData[1],
                        state: D.state ? D.state : formattedData[2],
                    },
                ];
            }

            let returnData = JSON.parse(JSON.stringify(statusOrder)).reverse();
            var findIndex = returnData.findIndex((status) => {
                return status.status == "ARRIVED_RETURN";
            });
            var D = returnData[findIndex];
            if (D && D.address && D.address.address) {
                let formattedData = D.address.address.split(",");
                location.to = [
                    {
                        company: D.company,
                        street: formattedData[0],
                        city: D.city ? D.city : formattedData[1],
                        state: D.state ? D.state : formattedData[2],
                    },
                ];
            }

            let dataForDrop = JSON.parse(JSON.stringify(statusOrder));
            if (findIndexForDelivery != -1) {
                var splicedDrop = dataForDrop
                    .splice(findIndexForDelivery, dataForDrop.length)
                    .reverse();
                var findIndexForDrop = splicedDrop.findIndex((status) => {
                    return status.status == "DROPPED";
                });

                if (
                    findIndexForDrop != -1 &&
                    splicedDrop[findIndexForDrop] &&
                    splicedDrop[findIndexForDrop].isCompleted
                ) {
                    var D = splicedDrop[findIndexForDrop];
                    if (D && D.address && D.address.address) {
                        let formattedData = D.address.address.split(",");
                        location.from = [
                            {
                                company: D.company,
                                street: formattedData[0],
                                city: D.city ? D.city : formattedData[1],
                                state: D.state ? D.state : formattedData[2],
                            },
                        ];
                    }
                }
            }
        }
        if (status == "NEED_TO_GET_DROP") {
            var driverId;
            var hasChanged = false;
            statusOrder.forEach((status, index) => {
                if (index == 0) {
                    driverId = status.driver;
                } else {
                    if (status.driver != driverId) {
                        hasChanged = true;
                    }
                }
            });
            var findIndexForDelivery = statusOrder.findIndex((status) => {
                return status.status == "DELIVERED";
            });
            var D = statusOrder[findIndexForDelivery];
            if (D && D.address && D.address.address) {
                let formattedData = D.address.address.split(",");
                location.from = [
                    {
                        company: D.company,
                        street: formattedData[0],
                        city: D.city ? D.city : formattedData[1],
                        state: D.state ? D.state : formattedData[2],
                    },
                ];
            }
            let dataForDrop = JSON.parse(JSON.stringify(statusOrder)).reverse();
            var findIndexForDrop = dataForDrop.findIndex((status) => {
                return status.status == "DROPPED" && status.isCompleted;
            });
            if (findIndexForDrop != -1) {
                var D = dataForDrop[findIndexForDrop];
                if (D && D.address && D.address.address) {
                    let formattedData = D.address.address.split(",");
                    location.to = [
                        {
                            company: D.company,
                            street: formattedData[0],
                            city: D.city ? D.city : formattedData[1],
                            state: D.state ? D.state : formattedData[2],
                        },
                    ];
                }
            } else {
                var findIndex = statusOrder.findIndex((status) => {
                    return status.status == "ARRIVED_RETURN";
                });
                var D = statusOrder[findIndex];
                if (D && D.address && D.address.address) {
                    let formattedData = D.address.address.split(",");
                    location.to = [
                        {
                            company: D.company,
                            street: formattedData[0],
                            city: D.city ? D.city : formattedData[1],
                            state: D.state ? D.state : formattedData[2],
                        },
                    ];
                }
            }
            let dataForNeedToGetDrop = JSON.parse(JSON.stringify(statusOrder));
            if (findIndexForDelivery != -1) {
                var splicedDrop = dataForNeedToGetDrop.splice(
                    findIndexForDelivery,
                    dataForNeedToGetDrop.length
                );
                var findIndexForDrop = splicedDrop.findIndex((status) => {
                    return status.status == "NEED_TO_GET_DROP";
                });

                if (
                    findIndexForDrop != -1 &&
                    splicedDrop[findIndexForDrop] &&
                    splicedDrop[findIndexForDrop].isCompleted
                ) {
                    var D = splicedDrop[findIndexForDrop];
                    if (D && D.address && D.address.address) {
                        let formattedData = D.address.address.split(",");
                        location.from = [
                            {
                                company: D.company,
                                street: formattedData[0],
                                city: D.city ? D.city : formattedData[1],
                                state: D.state ? D.state : formattedData[2],
                            },
                        ];
                    }
                }
            }
        }
        return location;
    };


    approveDeduction = (params) => {
        params.from = "Driver Pay";
        this.setState({ rowIndex: params.key })
        approveNewDeduction(params).then((response) => {
            let transcations = JSON.parse(JSON.stringify(this.state.transcations));

            if (!response.data.data._id && typeof response.data.data === 'string') {
                toastr.show(response.data.data, 'error');
                return;
            }
            transcations = transcations.map((trans) => {
                if (trans._id == response.data.data._id) {
                    let data = response.data.data;
                    trans.lock = data.lock;
                    trans.approved = data.approved;
                }
                return trans;
            });
            this.setState({ transcations });

            if (params.approved) {
                toastr.show("Approved!", "success");
            } else {
                toastr.show("This has been unapproved.", "success");
            }
           
        });
    };
    calculateAmount = (amount, additionalPrice) => {
        let totalAmount = amount.toFixed(2);
        let otherAmount = [];
        if (
            additionalPrice &&
            additionalPrice.length > 0 &&
            Array.isArray(additionalPrice)
        ) {
            additionalPrice.forEach((price) => {
                if (price && price != "") {
                    otherAmount.push(`${price.name} = ${price.amount.toFixed(2)}`);
                }
            });
        }
        if (otherAmount.length > 0) {
            return `${totalAmount}, ${otherAmount.join(",")}`;
        } else {
            return `${totalAmount}`;
        }
    };

    renderStatus = (status, reference_number) => {
        const firstLetter = reference_number?.substring(0, 1);
        let newStatus = "";
        switch (status) {
            case "ARRIVED_PICKUP":
                newStatus = firstLetter == "R" ? "Picked Up Load" : "Pulled Container";
                break;
            case "COMPLETED":
                newStatus = "Return Container";
                break;
            case "DELIVERED":
                newStatus = firstLetter == "R" ? "Delivered Load" : "Delivered";
                break;
            case "NEED_TO_GET_DROP":
                newStatus = "Get Container";
                break;
            default:
                newStatus = this.getPricingOptionsInStatus(status);
        }
        return newStatus;
    };

    updateRow(key, value, info,index) {
        const newP = { id: info._id, [key]: value }
        newP.isFromSettlement = false
        newP.isManual = true
        updateNewTranscation(newP).then((response) => {
            let transcations = this.state.transcations

            transcations.map((data) => {
                if (data._id == response.data.data._id) {
                    let obj = transcations.findIndex((obj) => obj._id === response.data.data._id)
                    let data = response.data.data;
                    transcations[obj] = data
                }
            })
           
            this.setState({ transcations: transcations })
            this.transitionEffect(`row-${index}`,true)
        }).catch((e) => {
            this.transitionEffect(`row-${index}`,false)
        })
    }


    getPricingOptionsInStatus = (str) => {
        if (str) {
            pricingSettingsOptions.forEach((opt) => {
                if (str.includes(opt.value)) {
                    let re = new RegExp(opt.value, "g");
                    str = str.replace(re, opt.label);
                }
            });
        }
        return str;
    };

    sortTable(sort) {
        this.setState({
            sort: !this.state.asce ? undefined : sort,
            asce: this.state.sort !== sort ? true : !this.state.asce,
        });
    }


    handleOnChange(key, value) {
       if(key==="from"||key==="to"){value=value.company_name}
        const NewDpay = { ...this.state.newDriverPay, [key]: value }
        this.setState({ newDriverPay: NewDpay, ShowDriverList: false }, () => {
            this.props.blockTabChange(true);
            if(key!="amount")this.unselectCell()})
    }

    handleChangeDate = (val, info, index) => {
        if (val) {
            let startDate = moment(new Date(val))
                .tz(this.userTimeZone)
                .startOf("weeks")
                .toISOString();
            let endDate = moment(new Date(val))
                .tz(this.userTimeZone)
                .endOf("weeks")
                .toISOString();

            const time = moment(new Date(val))
                .tz(this.userTimeZone)
                .toISOString();
            changeWeek({
                _id: info._id,
                from: info.from,
                startDate,
                endDate,
                createdBy: info.createdBy._id,
                time,
                hasSettlementSettings:
                    this.state.settlementSettings &&
                        this.state.settlementSettings.duration &&
                        this.state.settlementSettings.day
                        ? true
                        : false,
            }).then((response) => {
                const transcations = this.state.transcations.map((trans) => {
                    if (trans._id == response.data.data._id) {
                        let data = response.data.data;
                        trans.startDate = data.startDate;
                        trans.endDate = data.endDate;
                        trans.time = data.time;
                    }
                    return trans;
                });
                this.setState({ transcations,selectedCell:null, DateAndTime: null });
                this.transitionEffect(`row-${index}`,true)
                toastr.show("You have changed the settlement week. You must verify your settlements.", "success");
            }).catch(err => {
                this.transitionEffect(`row-${index}`,false)
            });
        }
    };

    update = (data) => {
        let rowId = null
        let transcations = JSON.parse(JSON.stringify(this.state.transcations));
        transcations = transcations.map((trans, index) => {
            if (trans._id == data._id) {
                data.profilePicture = trans?.profilePicture;
                trans = { ...data };
                rowId=index
            }
            return trans;
        });
        this.setState({ transcations });
        this.transitionEffect(`row-${rowId}`,true)
    };


    searchLoad = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm }, () => { });
    };

    onDateChange = (e, dateType) => {
        let dates = {
            fromDate: dateType === "fromDate"
                ? new Date(e)
                : this.state.fromDate
                    ? this.state.fromDate
                    : this.state.startDate,
            toDate:
                dateType === "toDate"
                    ? new Date(e)
                    : this.state.toDate
                        ? this.state.toDate
                        : this.state.endDate,
        };

        this.setState(
            {
                fromDate: dates.fromDate,
                toDate: dates.toDate,
                isDateRange: true,
                isLoadingBarShow: true,
            },
            () => {
                let query = {
                    fromDate: moment(this.state.fromDate)
                        .tz(this.userTimeZone)
                        .toISOString(),
                    toDate: moment(this.state.toDate)
                        .tz(this.userTimeZone)
                        .toISOString(),
                };
                this.getTranscation(query);
            }
        );
    };

    handleAddDates = (e) => {
        if (e) {
            const startDate = moment(e)
                .tz(this.userTimeZone)
                .startOf("weeks")
                .toISOString();
            const endDate = moment(e)
                .tz(this.userTimeZone)
                .endOf("weeks")
                .toISOString();

            const time = moment(e)
                .tz(this.userTimeZone)
                .toISOString();
            const hasSettlementSettings =
                this.state.settlementSettings &&
                    this.state.settlementSettings.duration &&
                    this.state.settlementSettings.day
                    ? true
                    : false
            this.setState({ newDriverPay: { ...this.state.newDriverPay, startDate, endDate, time, hasSettlementSettings, date: time } })
        }
    };

    render() {
        let { transcations, filterStatus, isStatusHovered } = this.state;

        if (filterStatus.length > 0) {
            transcations = transcations.filter(
                (f) =>
                    filterStatus.includes(
                        moment(f.time).tz(this.userTimeZone).format("ddd")
                    ) && !f.approved
            );
        }
        if (this.state.searchTerm !== "") {
            transcations = transcations.filter(
                (info) =>
                    (info &&
                        info.createdBy &&
                        info.createdBy.name &&
                        info.createdBy.name
                            .toLowerCase()
                            .includes(this.state.searchTerm.toLowerCase())) ||
                    (info &&
                        info.reference_number &&
                        info.reference_number
                            .toLowerCase()
                            .includes(this.state.searchTerm.toLowerCase()))
            );
        }
        transcations.map((el) => {
            el.calculateAmount = this.calculateAmount(
                el.amount,
                el.additionalPrice
            )
            el.renderStatus = this.renderStatus(el.status, el.reference_number);
        });
        if (this.state.sort) {
            transcations = _.orderBy(
                transcations,
                trans => {
                    if (this.state.sort === 'from') {
                        return trans[this.state.sort] ? trans[this.state.sort].toLowerCase() : (trans.groupFrom && trans.groupFrom.toLowerCase())
                    } else if (this.state.sort === 'to') {
                        return trans[this.state.sort] ? trans[this.state.sort].toLowerCase() : (trans.groupTo && trans.groupTo.toLowerCase())
                    } else if (this.state.sort === 'calculateAmount') {
                        return Number(trans[this.state.sort])
                    } else if (this.state.sort === 'createdBy.name') {
                        return trans.createdBy.name.toLowerCase()
                    } else if (this.state.sort === "fleetTruckOwner.company_name") {
                        return trans.fleetTruckOwner && trans.fleetTruckOwner.company_name ? trans.fleetTruckOwner.company_name.toLowerCase() : null
                    } else if (this.state.sort === "truck.equipmentID") {
                        return trans.truck && trans.truck.equipmentID ? trans.truck.equipmentID.toLowerCase() : null
                    } else if (this.state.sort === "terminal.name") {
                        return trans.terminal.name ? trans.terminal.name.toLowerCase() : null
                    } else {
                        return trans[this.state.sort].toLowerCase()
                    }
                },
                !this.state.asce && "desc"
            );

        }
        let Terminal = [];
        if (this.state.terminals && this.state.terminals.length > 0) {
            Terminal = JSON.parse(JSON.stringify(this.state.terminals));
            Terminal = Terminal.map((Data) => {
                return {
                    value: Data._id,
                    label: Data.name,
                };
            });
        }

        return (

            <div>
                <div class="card p-15 mb-0 d-flex flex-row align-items-center justify-content-between border-top">
                    <div className="d-flex align-items-center false">
                        <div className="app-search header-search mr-20">
                            <span className="search-icon"> </span>
                            <div className="position-relative">
                                <input
                                    className="form-control input-search-left"
                                    name=""
                                    id="acReceivableSearch"
                                    placeholder="Search"
                                    value={this.state.searchTerm}
                                    onChange={this.searchLoad}
                                />
                            </div>
                        </div>
                        {showForCompany() && (
                            <React.Fragment>
                                <div className="form-group mb-0 position-relative">
                                    <div className="input-wrapper">
                                        <DateWrapper
                                            onChange={(e) => this.onDateChange(e, "fromDate")}
                                            OnBlurUpdate={() => { this.setState({ filterFrom: false }) }}
                                            defaultDate={this.state.fromDate ? moment(this.state.fromDate) : moment(this.state.startDate)}
                                            displayTimeZone={this.userTimeZone}
                                            hideShowSelectDate={true}
                                            timeFormat={this.userTimeFormat ? "MM/DD/yyyy HH:mm": false}
                                        />
                                        <div className="input-icon">
                                            <IconCalendar />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-0 ml-2 position-relative">
                                    <div className="input-wrapper">
                                        <DateWrapper
                                            onChange={(e) => this.onDateChange(e, "toDate")}
                                            OnBlurUpdate={() => { this.setState({ filterTo: false }) }}
                                            defaultDate={this.state.toDate ? moment(this.state.toDate) : moment(this.state.endDate)}
                                            displayTimeZone={this.userTimeZone}
                                            hideShowSelectDate={true}
                                            timeFormat={this.userTimeFormat ? "MM/DD/yyyy HH:mm": false}
                                        />
                                        <div className="input-icon">
                                            <IconCalendar />
                                        </div>
                                    </div>
                                </div>
                                {this.state.isTerminal && (['fleetmanager', 'carrier'].includes(getStorage('currentUserRole')) > -1) && (
                                    <div className="form-group mb-0 ml-2 position-relative">
                                        <Select
                                            onChange={(choosenTerminals) =>
                                                this.setState({ choosenTerminals }, () => {
                                                    this.onChangeTerminal();
                                                })
                                            }
                                            isMulti
                                            isClearable={true}
                                            styles={newSmallSelectStyle}
                                            name="choosenTerminals"
                                            options={Terminal}
                                            className="basic-multi-select w-150"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>

                <div
                    className=""
                    style={{ height: "calc(100vh - 285px})" }}
                >
                    <table className="table table-card payment-table">
                        <div className="position-relative" ref={this.setWrapperRef} >
                            {this.state.isLoadingBarShow && <LoaderBar></LoaderBar>}
                            {this.state.isApiCall && <div className="overly-lays d-flex justify-content-center align-items-center text-white">
                                <span
                                    class="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Processing...
                            </div>}
                            <thead>
                                <tr>
                                    {((getStorage("currentUserRole") == "fleetmanager" &&
                                        configuration.idForTerminal.indexOf(
                                            JSON.parse(getStorage("loggedInUser")).fleetManager
                                                .carrier
                                        ) != -1) ||
                                        (getStorage("currentUserRole") == "carrier" &&
                                            configuration.idForTerminal.indexOf(
                                                getStorage("currentUserID")
                                            ) != -1)) && (
                                            <th
                                                style={{width: '15%'}}
                                                scope="col"
                                                onClick={() =>
                                                    sortingOptions.hasOwnProperty("Terminal") &&
                                                    this.sortTable(sortingOptions["Terminal"])
                                                }
                                                className={`${sortingOptions.hasOwnProperty('Terminal') && (this.state.sort == undefined || this.state.sort !== sortingOptions['Terminal'])
                                                    ? 'table-sort table-sort--default'
                                                    : (sortingOptions.hasOwnProperty('Terminal') ? this.state.sort === sortingOptions['Terminal'] && this.state.asce == true ? 'table-sort table-sort--ascending' : 'table-sort table-sort--descending' : '')}`}
                                            >
                                                Terminal
                                                {
                                                    sortingOptions.hasOwnProperty("Terminal")
                                                }
                                            </th>
                                        )}
                                    {[
                                        "Driver",
                                        "Status",
                                        "From",
                                        "To",
                                        "Amount",
                                        "Time",
                                    ].map((str) => (
                                        <th
                                            key={str}
                                            style={{width: "15%"}}
                                            scope="col"
                                            onClick={() =>
                                                sortingOptions.hasOwnProperty(str) &&
                                                this.sortTable(sortingOptions[str])
                                            }
                                            className={`${str === "Amount" && 'text-right' } ${str === "Time" && 'text-center' }  ${sortingOptions.hasOwnProperty(str) && (this.state.sort == undefined || this.state.sort !== sortingOptions[str])
                                                ? 'table-sort table-sort--default'
                                                : (sortingOptions.hasOwnProperty(str) ? this.state.sort === sortingOptions[str] && this.state.asce == true ? 'table-sort table-sort--ascending' : 'table-sort table-sort--descending' : '')} z-0`}
                                        >
                                            {str}
                                        </th>
                                    ))}
                                    <th style={{width: '10%'}} scope="col" className=" text-center"></th>
                                    <th style={{width: '2.75%'}} scope="col" className=" text-center"></th>
                                    <th style={{width: '15%'}} scope="col" className=" text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {transcations &&
                                    transcations.map((info, key) => {
                                        let address = undefined;
                                        if (info.statusOrder && !info.loadId) {
                                            address = this.getLocation(
                                                info.statusOrder,
                                                info.createdBy,
                                                info.status
                                            );
                                        } else {
                                            address = getDriverOrderLocation(
                                                info.loadId ? info.loadId.driverOrder : [],
                                                info.createdBy,
                                                info.status
                                            );
                                        }
                                        if (info.terminal && !info.terminal.name) {
                                            info.terminal = this.state.terminals.find(
                                                (terminal) => terminal._id == info.terminal
                                            );
                                        }
                                        let conditionForWeekChange = true;
                                        if (info.lock) {
                                            conditionForWeekChange = false;
                                        }
                                        if (info.lock && info.approved != true) {
                                            conditionForWeekChange = true;
                                        }
                                        if (info.lock && info.approved == true) {
                                            conditionForWeekChange = false;
                                        }
                                        // Get From And to
                                        let from = info.from ? info.from : "";
                                        let to = info.to ? info.to : "";
                                        // paymenttype is DYNAMIC DRIVER
                                        if (
                                            info &&
                                            info.paymentType &&
                                            info.paymentType.includes("DYNAMIC DRIVER")
                                        ) {
                                            from = info.from;
                                            to = info.to;
                                        } else {
                                            if (info.isManual && info.from) {
                                                if (
                                                    info.from != "undefined" &&
                                                    info.from != undefined &&
                                                    info.from != "transcation"
                                                ) {
                                                    from = info.from;
                                                }
                                            }
                                            if (info.groupFrom) {
                                                from = info.groupFrom;
                                            }
                                            if (
                                                !from &&
                                                !info.groupForm &&
                                                address &&
                                                address.from.length > 0
                                            ) {
                                                from = address.from.map((address, keya) => {
                                                    return (
                                                        <span key={keya}>
                                                            {address.company ? `${address.company}` : ""}
                                                            {address.city ? `, ${address.city}` : ""}
                                                            {address.state ? `, ${address.state}` : ""}
                                                        </span>
                                                    );
                                                });
                                            }
                                            // To
                                            if (info.isManual && info.to) {
                                                to = info.to;
                                            }
                                            if (info.groupTo) {
                                                to = info.groupTo;
                                            }
                                            if (
                                                !to &&
                                                !info.groupTo &&
                                                address &&
                                                address.to.length > 0
                                            ) {
                                                to = address.to.map((address, keya) => {
                                                    return (
                                                        <div key={keya}>
                                                            {keya == 1 && <p>-----------</p>}
                                                            <span>
                                                                {address.company
                                                                    ? `${address.company}`
                                                                    : ""}
                                                                {address.city ? `, ${address.city}` : ""}
                                                                {address.state ? `, ${address.state}` : ""}
                                                            </span>
                                                        </div>
                                                    );
                                                });
                                            }
                                        }
                                        let status = this.renderStatus(
                                            info.status,
                                            info.reference_number
                                        )
                                        let isHovering = isStatusHovered === info._id;
                                        return (
                                            <>
                                                <tr
                                                    className={` select-custom-input inline-table-row row-${key} inline-table-row ${this.state.addDriverPay && "disabled-pointer-events"} `}
                                                    key={key}
                                                    style={{
                                                        opacity: `${this.state.addDriverPay
                                                            ? "0.2"
                                                            : ""
                                                            } `,
                                                        transition:
                                                            "background .4s ease-out",
                                                    }}
                                                >
                                                    {((getStorage("currentUserRole") ==
                                                        "fleetmanager" &&
                                                        configuration.idForTerminal.indexOf(
                                                            JSON.parse(
                                                                getStorage("loggedInUser")
                                                            ).fleetManager.carrier
                                                        ) != -1) ||
                                                        (getStorage("currentUserRole") ==
                                                            "carrier" &&
                                                            configuration.idForTerminal.indexOf(
                                                                getStorage("currentUserID")
                                                            ) != -1)) && (
                                                            <td
                                                            onClick={()=>this.unselectCell()}
                                                            >
                                                                {info.terminal && info.terminal.name}
                                                            </td>
                                                        )}
                                                    <td
                                                    onClick={()=>this.unselectCell()}
                                                    >
                                                        {
                                                            info.profilePicture ?
                                                                <div className="d-flex align-items-center justify-content-start">
                                                                    <Avatar src={info.profilePicture} className='mr-2'></Avatar>
                                                                    {info && info.createdBy && info.createdBy.name ? info.createdBy.name : " "}{" "}
                                                                    {info && info.createdBy && info.createdBy.lastName ? info.createdBy.lastName : ""}
                                                                </div>
                                                                :
                                                                <div className="d-flex align-items-center justify-content-start">
                                                                    <Avatar className='mr-2'>{displayName(info.createdBy.name + ' ' + info.createdBy.lastName)}</Avatar>
                                                                    {info && info.createdBy && info.createdBy.name ? info.createdBy.name : " "}{" "}
                                                                    {info && info.createdBy && info.createdBy.lastName ? info.createdBy.lastName : ""}
                                                                </div>
                                                        }
                                                    </td>
                                                    <td
                                                    className={`pointer cell-${key}-1 pr-1 ${this.state.selectedCell === `update-status-${key}` && 'newdriverrow td-clicked'}`}
                                                     onClick={() => this.selectCell(`update-status-${key}`)}
                                                    >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                            {status || <span className="text-muted">Select Status</span>}
                                                            <IconAngleArrowDown className='' />
                                                            {this.state.selectedCell === `update-status-${key}` &&
                                                                <SelectCustomComponent
                                                                    name='status'
                                                                    searchable={true}
                                                                    refClassName={`cell-${key}-1`}
                                                                    listData={this.state.allLoadStatus}
                                                                    onSelect={(name,value)=>{
                                                                        this.updateRow(name,value,info,key)
                                                                        this.unselectCell()
                                                                    }}
                                                                    onCreateOption={this.createStatus}
                                                                    onDeleteItem={this.removeStatus}
                                                                    unselectCell={this.unselectCell}
                                                                    removeItem={this.deleteStatus}
                                                                />}
                                                        </div>
                                                       
                                                    </td>
                                                    <td
                                                    className={`pointer cell-${key}-2 pr-1 ${this.state.selectedCell === `update-from-${key}` && 'newdriverrow td-clicked'}`}
                                                        onClick={() => this.selectCell(`update-from-${key}`)}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center 234">
                                                            {from || <span className="text-muted">From a Company</span>}
                                                            <IconAngleArrowDown className='' />
                                                            {this.state.selectedCell === `update-from-${key}` &&
                                                                <SelectCustomComponent
                                                                    name='from'
                                                                    searchable={true}
                                                                    refClassName={`cell-${key}-2`}
                                                                    listData={this.props.allCustomers}
                                                                    onSelect={(name, value) => {
                                                                        this.updateRow(name, value.company_name, info, key)
                                                                        this.unselectCell()
                                                                    }}
                                                                    loadOptions={this.getFromTo}
                                                                    keyName="company_name"
                                                                    unselectCell={this.unselectCell}
                                                                />}
                                                        </div>
                                                    </td>
                                                    <td
                                                        className={`pointer cell-${key}-3 pr-1 ${this.state.selectedCell === `update-to-${key}` && 'newdriverrow td-clicked'}`}
                                                        onClick={() => this.selectCell(`update-to-${key}`)}
                                                    >

                                                        <div className="d-flex justify-content-between align-items-center">
                                                            {to || <span className="text-muted">To a Company</span>}
                                                            <IconAngleArrowDown className='' />
                                                            {this.state.selectedCell === `update-to-${key}` &&
                                                                <SelectCustomComponent
                                                                    name="to"
                                                                    refClassName={`cell-${key}-3`}
                                                                    searchable={true}
                                                                    listData={this.props.allCustomers}
                                                                    onSelect={(name, value) => {
                                                                        this.updateRow(name, value.company_name, info, key)
                                                                        this.unselectCell()
                                                                    }}
                                                                    loadOptions={this.getFromTo}
                                                                    keyName="company_name"
                                                                    unselectCell={this.unselectCell}
                                                                />}
                                                        </div>
                                                    </td>

                                                    <td
                                                        className={`pointer cell-${key}-4  ${this.state.selectedCell === `update-amount-${key}` && 'newdriverrow td-clicked'}`}
                                                        onClick={() => this.selectCell(`update-amount-${key}`)}
                                                    >
                                                        <NumberFormater
                                                            key={key + info._id + info.amount}
                                                            update={this.update}
                                                            form={info._id}
                                                            initialValues={{
                                                                amount: info.amount.toFixed(2),
                                                                id: info._id,
                                                                reference_number: info.reference_number,
                                                            }}
                                                            label={this.renderStatus(
                                                                info.status,
                                                                info.reference_number
                                                            )}
                                                            unselectCell={this.unselectCell}
                                                        ></NumberFormater>
                                                    </td>
                                                    <td 
                                                      className={`pointer ${this.state.selectedCell === `update-date-${key}` && 'newdriverrow td-clicked'}`}
                                                      onClick={() => {
                                                        let isDateSelect = `isDateSelect${key}`;
                                                        this.setState({ [isDateSelect]: true })
                                                          this.selectCell( `update-date-${key}`)
                                                      }}>
                                                        <div className="selectDate position-relative bg-transparent">
                                                            <div className={`${!info.time && 'text-center'}`}>
                                                                {info.time ? moment(info.time)
                                                                    .tz(this.userTimeZone)
                                                                    .format("MM/DD") : "-"}
                                                            </div>
                                                            <div className="text-muted">
                                                                {info.time && moment(info.time)
                                                                    .tz(this.userTimeZone)
                                                                    .format(`${this.userTimeFormat ? "HH:mm" : "hh:mm a"}`)}
                                                            </div>
                                                        </div>
                                                        { this.state[`isDateSelect${key}`] &&
                                                            <div>
                                                                <DateTimePicker
                                                                    dateFormat="MM/DD"
                                                                    displayTimeZone={this.userTimeZone}
                                                                    timeFormat={this.userTimeFormat ? "MM/DD/yyyy HH:mm": false}
                                                                    onChange={(e) => {this.setState({ DateAndTime: e })}}
                                                                    defaultDate={info.time &&
                                                                        moment(info.time).tz(this.userTimeZone).format("lll")
                                                                    }
                                                                    dontShowSelectDate={true}
                                                                    isShowTime={true}
                                                                    hideShowSelectDate={true}
                                                                    className="right-0"
                                                                    OnBlurUpdate={() => {
                                                                        let isDateSelect = `isDateSelect${key}`;
                                                                        this.setState({ [isDateSelect]: false })
                                                                        this.unselectCell()
                                                                        this.handleChangeDate(this.state.DateAndTime, info, key)
                                                                    }}
                                                                />
                                                            </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        {info.isDraft &&
                                                            <span class="pointer d-block text-center badge badge-soft-primary">
                                                                DRAFT
                                                            </span>
                                                        }
                                                        {!info.isDraft && (info.lock &&
                                                            info.approved === true ? (
                                                            <span className="pointer  d-block badge badge-purple-50 py-1 ">
                                                                Completed
                                                            </span>
                                                        ) : info.approved === true ? (
                                                            <Fragment>
                                                                <span
                                                                    className={`pointer d-block text-center badge ${isHovering
                                                                        ? "badge-danger"
                                                                        : "badge-accent-100"
                                                                        }`}
                                                                    onMouseEnter={() =>
                                                                        this.setState({
                                                                            isStatusHovered:
                                                                                info._id,
                                                                        })
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        this.setState({
                                                                            isStatusHovered: null,
                                                                        })
                                                                    }
                                                                    onClick={() =>
                                                                        this.approveDeduction({
                                                                            _id: info._id,
                                                                            approved: info.approved
                                                                                ? false
                                                                                : true,
                                                                            key: key
                                                                        })
                                                                    }
                                                                >
                                                                    {isHovering ? (
                                                                        <span>UnApprove</span>
                                                                    ) : (
                                                                        <span>Approved</span>
                                                                    )}
                                                                </span>
                                                            </Fragment>
                                                        ) : (
                                                            <span
                                                                className={`pointer d-block text-center badge ${isHovering
                                                                    ? "badge-success"
                                                                    : "badge-danger-light"
                                                                    }`}
                                                                onMouseEnter={() =>
                                                                    this.setState({
                                                                        isStatusHovered: info._id,
                                                                    })
                                                                }
                                                                onMouseLeave={() =>
                                                                    this.setState({
                                                                        isStatusHovered: null,
                                                                    })
                                                                }
                                                                onClick={() =>
                                                                    this.approveDeduction({
                                                                        _id: info._id,
                                                                        approved: info.approved
                                                                            ? false
                                                                            : true,
                                                                        key: key
                                                                    })
                                                                }
                                                            >
                                                                {isHovering ? (
                                                                    <span>Approve</span>
                                                                ) : (
                                                                    <span>Unapproved</span>
                                                                )}
                                                            </span>
                                                        ))}
                                                    </td>
                                                    {<RedirectToRates
                                                        info={info}
                                                        redirectToRates={this.redirectToRates}
                                                        style={{ minWidth: "42px" }}
                                                    />}
                                                    {<DeleteCell
                                                        info={info}
                                                        deleteNewDriverPay={this.deleteNewDriverPay}
                                                    />}
                                                </tr>
                                            </>

                                        );
                                    })}
                                {this.state.addDriverPay &&
                                    (<tr
                                        className={`shadow-md select-custom-input position-relative ${this.state.isFailed} ${this.state.isApiCall && 'loading'} newdriverrow rounded-1`}
                                        id="outline"
                                        style={{ transition: 'background .4s ease-out' }}
                                        ref={this.wrapperRef}
                                        onKeyDown={(e) => { !this.state.isApiCall && e.keyCode === 13 && this.addManual() }}
                                    >

                                    {((getStorage("currentUserRole") ==
                                        "fleetmanager" &&
                                        configuration.idForTerminal.indexOf(
                                            JSON.parse(getStorage("loggedInUser"))
                                                .fleetManager.carrier
                                        ) != -1) ||
                                        (getStorage("currentUserRole") == "carrier" &&
                                            configuration.idForTerminal.indexOf(
                                                getStorage("currentUserID")
                                            ) != -1)) && (
                                            <td
                                                className={`pointer cell-1 ${this.state.selectedCell === "add-terminal" && 'newdriverrow td-clicked'}`}
                                                
                                                onClick={() => this.selectCell("add-terminal","pointer cell-1")}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {this.state.newDriverPay?.terminal?.label || "Select Terminal"}
                                                    <IconAngleArrowDown className='' />
                                                    {this.state.selectedCell === "add-terminal" &&
                                                        <SelectCustomComponent
                                                            name='terminal'
                                                            searchable={true}
                                                            refClassName="cell-1"
                                                            listData={Terminal}
                                                            onSelect={this.handleOnChange}
                                                            keyName="label"
                                                            unselectCell = {this.unselectCell}
                                                            width={this.state.width}
                                                        />}
                                                </div>
                                            </td>
                                        )}
                                    <td
                                        className={`pointer cell-2 ${this.state.isFailed === "transition-white-field" && this.state.newDriverPay.driver ? "transition-white-field" : this.state.isRequied} ${!this.state.newDriverPay.driver && 'requied_hover'}
                                            ${this.state.selectedCell === "add-driver" && 'newdriverrow td-clicked'}`}
                                        style={{ width: "195px", transition: 'background .4s ease-out' }}
                                        onClick={() => this.selectCell("add-driver")}
                                    >
                                            <div className="font-12 d-flex justify-content-between"
                                               >
                                                {this.state.newDriverPay.driver ? <div className="d-flex align-items-center">
                                                    <span className="avatar-circle avatar-xs mr-1">
                                                        {this.state.newDriverPay?.driver?.label.charAt(
                                                            0
                                                        )}
                                                    </span>
                                                    {this.state.newDriverPay?.driver &&
                                                        this.state.newDriverPay?.driver.label}
                                                </div> : <div className="text-center w-100" >
                                                    <div className="position-relative d-inline-block">
                                                        <div className="pointer">
                                                            <CustomIconAddUser />
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.selectedCell === "add-driver" &&
                                                    <SelectCustomComponent
                                                        name="driver"
                                                        searchable={true}
                                                        refClassName="cell-2"
                                                        keyName="label"
                                                        listData={this.state.allDrivers}
                                                        onSelect={(name,el)=>this.handleOnChange("driver",el)}
                                                        unselectCell = {this.unselectCell}
                                                        loadOptions={this.getDriverList}
                                                    />
                                                }
                                            </div>
                                        </td>
                                        <td
                                            className={`pointer cell-3 pr-1 ${this.state.isFailed === "transition-white-field" && this.state.newDriverPay.status ? "transition-white-field" : this.state.isRequied} ${!this.state.newDriverPay.status && 'requied_hover'} 
                                            ${this.state.selectedCell === "add-status" && 'newdriverrow td-clicked'}
                                            `}
                                            style={{ width: "195px", transition: 'background .4s ease-out' }}
                                            onClick={() => this.selectCell("add-status")}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                {this.state.newDriverPay?.status || "Select Status"}
                                                <IconAngleArrowDown className='' />
                                                {this.state.selectedCell === "add-status" &&
                                                    <SelectCustomComponent
                                                        name='status'
                                                        searchable={true}
                                                        refClassName="cell-3"
                                                        listData={this.state.allLoadStatus}
                                                        onSelect={this.handleOnChange}
                                                        onCreateOption={this.createStatus}
                                                        onDeleteItem={this.removeStatus}
                                                        unselectCell = {this.unselectCell}
                                                    />}
                                            </div>
                                        </td>
                                        <td
                                        className={`pointer cell-4 pr-1 ${this.state.isFailed === "transition-white-field" && this.state.newDriverPay.from ? "transition-white-field" : this.state.isRequied} ${!this.state.newDriverPay.from && 'requied_hover'}
                                            ${this.state.selectedCell === "add-from" && 'newdriverrow td-clicked'}
                                            `}
                                        style={{ width: "195px", }}
                                        onClick={() => this.selectCell("add-from")}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            {this.state.newDriverPay?.from || "From a Company"}
                                            <IconAngleArrowDown className='' />
                                            {this.state.selectedCell === "add-from" &&
                                                <SelectCustomComponent
                                                    name='from'
                                                    searchable={true}
                                                    refClassName="cell-4"
                                                    listData={this.props.allCustomers}
                                                    loadOptions={this.getFromTo}
                                                    onSelect={this.handleOnChange}
                                                    keyName="company_name"
                                                    unselectCell={this.unselectCell}
                                                />}
                                        </div>
                                    </td>
                                        <td
                                            className={`pointer cell-5  pr-1 ${this.state.isFailed === "transition-white-field" && this.state.newDriverPay.to ? "transition-white-field" : this.state.isRequied} ${!this.state.newDriverPay.to && 'requied_hover'}
                                            ${this.state.selectedCell === "add-to" && 'newdriverrow td-clicked'}
                                            `}
                                            style={{ width: "195px", transition: 'background .4s ease-out' }}
                                            onClick={() => this.selectCell( "add-to")}
                                        >
                                            <div className="font-12 d-flex justify-content-between align-items-center" >

                                                {this.state.newDriverPay?.to || "To a Company"}
                                                <IconAngleArrowDown className='' />
                                                {this.state.selectedCell === "add-to" &&
                                                    <SelectCustomComponent
                                                        name='to'
                                                        searchable={true}
                                                        refClassName="cell-5"
                                                        loadOptions={this.getFromTo}
                                                        listData={this.props.allCustomers}
                                                        onSelect={this.handleOnChange}
                                                        keyName="company_name"
                                                        unselectCell={this.unselectCell}
                                                    />}
                                            </div>
                                        </td>


                                        <td className={`pointer cell-6 pr-20 ${this.state.isFailed === "transition-white-field" && this.state.newDriverPay.amount ? "transition-white-field" : this.state.isRequied} "font-14 text-right text-dark" ${!this.state.newDriverPay.amount && 'requied_hover'}
                                          ${this.state.selectedCell === "add-amount" && 'newdriverrow td-clicked'}
                                        `}
                                            style={{ transition: 'background .4s ease-out', width: '120px' }}
                                            onClick={() => this.selectCell( "add-amount")}
                                        >
                                            <input
                                                className="form-control border-0 font-14 text-right text-dark bg-transparent p-0 line-height-30"
                                                placeholder="$0.00"
                                                type="text"
                                                onKeyPress={(event) => {
                                                    if (!/[0-9.]/.test(event.key) || (event.target.value.indexOf('.')!=-1 && event.key===".")) {
                                                      event.preventDefault();
                                                    }
                                                }}
                                                value={this.state.newDriverPay.amount && `$${this.state.newDriverPay.amount}`}
                                                onChange={(e) => this.handleOnChange("amount", e.target.value.replace('$', '').trim())}
                                                onBlur={this.unselectCell}
                                            />
                                        </td>
                                        <td
                                            className={`pointer cell-7 ${this.state.isFailed === "transition-white-field" && this.state.newDriverPay.date ? "transition-white-field" : this.state.isRequied} ${!this.state.newDriverPay.date && 'requied_hover'}
                                            ${this.state.selectedCell === "add-date" && 'newdriverrow td-clicked'}
                                            `}
                                            style={{ transition: 'background .4s ease-out' }}
                                            onClick={() => {
                                                this.setState({
                                                    isDateSelect: true,
                                                })
                                                this.selectCell("add-date")
                                            }}
                                        >
                                            <div tabindex="1" id="driverPay-selectDate" className="selectDate position-relative bg-transparent">

                                                <div className={`${!this.state.newDriverPay?.date && 'text-center'}`}>
                                                    {this.state.newDriverPay.date ? moment(this.state.newDriverPay.date)
                                                        .tz(this.userTimeZone)
                                                        .format("MM/DD") : "-"}
                                                </div>
                                                <div className="text-muted">
                                                    {this.state.newDriverPay.date && moment(this.state.newDriverPay.date)
                                                        .tz(this.userTimeZone)
                                                        .format(`${this.userTimeFormat ? "HH:mm" : "hh:mm a"}`)}
                                                </div>

                                            </div>
                                            {this.state.isDateSelect && this.state.selectedCell === "add-date" &&
                                                <div className="date-time-popup">
                                                    <DateTimePicker
                                                        dateFormat="MM/DD"
                                                        displayTimeZone={this.userTimeZone}
                                                        timeFormat={this.userTimeFormat ? "MM/DD/yyyy HH:mm": false}
                                                        onChange={(e) => this.handleAddDates(e)}
                                                        defaultDate={this.state.newDriverPay.date &&
                                                            moment(this.state.newDriverPay.date).tz(this.userTimeZone).format("lll")
                                                        }
                                                        dontShowSelectDate={true}
                                                        isShowTime={true}
                                                        hideShowSelectDate={true}
                                                        className="right-0"
                                                        OnBlurUpdate={() => {
                                                            this.setState({ isDateSelect: false })
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </td>
                                        <td>
                                        </td>
                                        <td style={{minWidth: "42px"}}>
                                        </td>
                                        <td>
                                            <Fragment>
                                                <button
                                                    onClick={() =>
                                                        this.setState({ addDriverPay: false, newDriverPay: newDriverPay ,isRequied:"transition-white-field"}, () => this.props.blockTabChange(false))
                                                    }
                                                    type="button"
                                                    className="btn btn-link text-muted pr-0 pl-0"
                                                >
                                                    <IconTrash />{" "}
                                                </button>

                                                <ReactTooltip id="delete" place="top">
                                                    <span>Delete</span>
                                                </ReactTooltip>
                                            </Fragment>


                                        </td>
                                    </tr>)
                                }

                            </tbody>
                        </div>
                    </table>
                    <div className='mt-10'>
                        <button
                            type="button"
                            class="btn btn-white btn-sm text-primary"
                            disabled={this.state.addDriverPay}
                            onClick={() => this.setState({ addDriverPay: true,isRequied:"transition-white-field",selectedCell:null })}
                        >
                            <IconPlus className="mr-2" />
                            Add Driver Pay
                        </button>
                    </div>
                </div>
            </div>

        )
    }
}



function mapStateToProps(state) {
    return {
        tmsLoads: state.TmsReducer.loads,
        drivers: state.TmsReducer.drivers,
        allCustomers: state.TmsReducer.allCustomers,
    };
}

export default connect(mapStateToProps, null)(DriverPay);